import { render, staticRenderFns } from "./AppsBanner.vue?vue&type=template&id=4b3cc5e6&scoped=true&"
import script from "./AppsBanner.vue?vue&type=script&lang=js&"
export * from "./AppsBanner.vue?vue&type=script&lang=js&"
import style0 from "./AppsBanner.vue?vue&type=style&index=0&id=4b3cc5e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3cc5e6",
  null
  
)

export default component.exports